var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.049 6.31a3.155 3.155 0 100-6.31 3.155 3.155 0 000 6.31zm-8.185 9.38L0 13.833l4.406-4.39a1.747 1.747 0 012.337-.12l3.277 2.656 3.23-2.611a1.748 1.748 0 012.336.12l4.36 4.345-1.864 1.857-3.793-3.78-3.17 2.561a1.759 1.759 0 01-2.202-.001l-3.215-2.605-3.838 3.825z"
  })));
}
export default SvgLogoSmall;